<template>
	<div class="vue-item">

		<div class="vue-item-ico" v-if="icoType!='none'">
			<div v-if="icoType=='select'" class="vue-item-ico__select"></div>
			<div v-if="icoType=='next'" class="vue-item-ico__next"></div>
		</div>

		<slot></slot>

		<div class="vue-item-mark">
			<div class="vue-item-txts" v-if="markSubject!=''|markSubjectAttach!=''">
				<p v-if="markSubject!=''" class="vue-item-mark__subject">{{markSubject}}</p>
				<p v-if="markSubjectAttach!=''" class="vue-item-mark__subject_attach">{{markSubjectAttach}}</p>
			</div>
			<!-- 左侧插槽 -->
			<slot name='mark'></slot>
		</div>

		<div class="vue-item-submark">
			<div class="vue-item-txts" v-if="submarkSubject!=''|submarkSubjectAttach!=''">
				<p v-if="submarkSubject!=''" class="vue-item-submark__subject">{{submarkSubject}}</p>
				<p v-if="submarkSubjectAttach!=''" class="vue-item-submark__subject_attach">{{submarkSubjectAttach}}</p>
			</div>
			<!-- 右侧插槽 -->
			<slot name='submark'></slot>
		</div>

	</div>
</template>
<style lang='less'>
	@import 'vue-item.less';
</style>
<script type="text/javascript">
	export default {
		name:'vue-item',
		data(){
			return {
			};
		},
		props:{
			markSubject:{
				type:String,
				default:''
			},
			markSubjectAttach:{
				type:String,
				default:''
			},
			submarkSubject:{
				type:String,
				default:''
			},
			submarkSubjectAttach:{
				type:String,
				default:''
			},
			icoType:{
				type:String,
				default:'none'
			}
		}
	}
</script>



// WEBPACK FOOTER //
// ../common-npm/flyme7/component/item/vue-item.vue